import {
  defaultGridUnit,
  palette,
  typography,
  defaultMultipliers,
} from "./constants";
import { components } from "./components";
import { TTheme } from "@ob/theme";

export const defaultTheme: TTheme = {
  palette,
  typography,
  components,
  spacing: {
    gridUnit: defaultGridUnit,
    multipliers: defaultMultipliers,
  },
};
